export default "__VITE_ASSET__ByJoeaOM__"